var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter"},[(_vm.initialized && _vm.ready)?_c('blog-entries',{attrs:{"type":_vm.type,"entries":_vm.list}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }